import React, { Component } from 'react';
import './mainpage.css';
import logo from './logo.png';
import { Button } from '@fluentui/react-components';
import { 
  Navigation24Regular,
  MailFilled,
  SearchFilled,
  SearchInfoFilled,
  OrganizationFilled,
  PeopleFilled,
  ScalesFilled
} from '@fluentui/react-icons';
import NavBar from './NavBar';

interface TermsProps {}

interface TermsState {
  isMenuOpen: boolean;
  isProductsMenuOpen: boolean;
  isSolutionsMenuOpen: boolean;
}

class TermsOfUse extends Component<TermsProps, TermsState> {
  constructor(props: TermsProps) {
    super(props);
    this.state = {
      isMenuOpen: false,
      isProductsMenuOpen: false,
      isSolutionsMenuOpen: false
    };
  }

  toggleMenu = () => {
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
  };

  toggleProductsMenu = () => {
    this.setState({ isProductsMenuOpen: !this.state.isProductsMenuOpen });
  };

  closeProductsMenu = () => {
    this.setState({ isProductsMenuOpen: false });
  };

  toggleSolutionsMenu = () => {
    this.setState({ isSolutionsMenuOpen: !this.state.isSolutionsMenuOpen });
  };

  closeSolutionsMenu = () => {
    this.setState({ isSolutionsMenuOpen: false });
  };

  render() {
    const { isMenuOpen } = this.state;

    return (
      <div className="main-page">
        {/* Top Navigation */}
        <NavBar />

        {/* Terms of Use Content */}
        {/* Terms of Use Content */}
        <section style={{ padding: '4rem 0', background: '#fff', minHeight: '70vh' }}>
          <div className="container">
            <div style={{ maxWidth: '900px', margin: '0 auto' }}>
              <h1 style={{ fontSize: '1.75rem', marginBottom: '1.5rem', color: '#111827', fontWeight: '700', textAlign: 'left' }}>TERMS OF USE</h1>
              
              <div style={{ lineHeight: '1.6', color: '#374151', fontSize: '0.875rem', textAlign: 'left' }}>
                <h2 style={{ fontSize: '1.25rem', marginTop: '2rem', marginBottom: '0.75rem', color: '#111827', fontWeight: '600', textAlign: 'left' }}>END USER LICENCE AGREEMENT</h2>
                
                <p style={{ marginBottom: '1rem' }}>
                  This End User License Agreement ("Agreement") is between the person or entity named in the Order Form who acquires the Software or the person or entity which has installed the Software ("Licensee" or "Customer") and the Greek company "Psarakis Antonios MON IKE" trading as "META 365" with registered office in Greece (Voulgaro Kisamou Chania) ("Licensor") from which Licensee are procuring Offerings (defined below) and governs Licensee's use of Offerings purchased through either Microsoft AppSource or Azure Marketplace (collectively, "Marketplace").
                </p>

                <p style={{ marginBottom: '1rem' }}>
                  This Agreement applies to all Orders entered into under this Agreement.
                </p>

                <h3 style={{ fontSize: '1.1rem', marginTop: '1.5rem', marginBottom: '0.5rem', color: '#111827', fontWeight: '600', textAlign: 'left' }}>1. DEFINITIONS</h3>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>"Affiliate"</strong> means any legal entity that controls, is controlled by, or is under common control with a party.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>"Anti-Corruption Laws"</strong> means all laws against fraud, bribery, corruption, inaccurate books and records, inadequate internal controls, money-laundering, and illegal software, including the U.S. Foreign Corrupt Practices Act.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>"Control"</strong> means ownership of more than a 50% interest of voting securities in an entity or the power to direct the management and policies of an entity.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>"Confidential Information"</strong> is defined in the "Confidentiality" section.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>"Customer Data"</strong> means all data, including all text, sound, software, image or video files that are provided to Licensor or its Affiliates by, or on behalf of, Licensee and its Affiliates through use of the Offering. Customer Data does not include Support Data.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>"Data Protection Law"</strong> means any law applicable to Publisher or Customer, relating to data security, data protection and/or privacy, including Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of natural persons with regard to processing of personal data and the free movement of that data ("GDPR"), and any implementing, derivative or related legislation, rule, regulation, and regulatory guidance, as amended, extended, repealed and replaced, or re-enacted.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>"Documentation"</strong> means all user manuals, handbooks, training material, requirements, and other written or electronic materials Licensor makes available for, or that result from use of, the Offering.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>"End User"</strong> means any person Customer permits to use an Offering or access Customer Data.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>"Feedback"</strong> means ideas, suggestions, comments, input, or know-how, in any form, that one party provides to the other in relation to recipient's Confidential Information, products, or services.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>"Offering"</strong> means all services, websites (including hosting), solutions, platforms, and products identified in an Order and that Licensor makes available under or in relation to this Agreement. Offering availability may vary by region.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>"Order"</strong> means an ordering document used to transact the Offering via the Marketplace.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>"Personal Data"</strong> means any information relating to an identified or identifiable natural person.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>"Support Data"</strong> means all data, including all text, sound, video, image files, or software, that are provided to Licensor by or on behalf of Customer through an engagement with Licensor to obtain technical support for the Offering.
                </p>

                <h3 style={{ fontSize: '1.1rem', marginTop: '1.5rem', marginBottom: '0.5rem', color: '#111827', fontWeight: '600', textAlign: 'left' }}>2. LICENSE</h3>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>2.1 License grant.</strong> Offerings are licensed and not sold. Upon acceptance of an Order, and subject to Licensee's compliance with this Agreement, Publisher grants Licensee a nonexclusive and limited license to use the ordered Offerings. These licenses are solely for Licensee's own use and business purposes and are nontransferable except as expressly permitted under this Agreement or applicable law.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>2.2 Duration of licenses.</strong> Licenses granted on a subscription basis expire at the end of the applicable subscription period set forth in the Order, unless renewed. Licenses granted for metered Offerings billed periodically based on usage continue as long as Licensee continues to pay for its usage of the Offerings.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>2.3 End Users.</strong> Licensee will control access to and use of the Offerings by End Users and is responsible for any use of the Offerings that does not comply with this Agreement.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>2.4 Affiliates.</strong> Licensee may order Offerings for use by its Affiliates. If it does, the licenses granted to Licensee under this Agreement will apply to such Affiliates, but Licensee will have the sole right to enforce this Agreement against Licensor.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>2.5 Reservation of Rights.</strong> Licensor reserves all rights not expressly granted in this Agreement. Offerings are protected by copyright and other intellectual property laws and international treaties.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>2.6 Restrictions.</strong> Except as expressly permitted in this Agreement, Documentation or an Order, Licensee must not: (a) copy, modify, reverse engineer, decompile, or disassemble any Offering; (b) install or use any third-party software or technology in any way that would subject Licensor's intellectual property to any other license terms; (c) work around any technical limitations in an Offering; (d) use an Offering for any unlawful purpose.
                </p>

                <h3 style={{ fontSize: '1.1rem', marginTop: '1.5rem', marginBottom: '0.5rem', color: '#111827', fontWeight: '600', textAlign: 'left' }}>3. PRIVACY</h3>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>3.1 EU Standard Contractual Clauses.</strong> To the extent applicable, the parties will abide by the requirements of European Economic Area and Swiss data protection law regarding the collection, use, transfer, retention, and other processing of Personal Data from the European Economic Area and Switzerland.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>3.2 Personal Data.</strong> Customer consents to the processing of Personal Data by Licensor and its Affiliates. Before providing Personal Data to Licensor, Customer will obtain all required consents from third parties under applicable privacy and Data Protection Laws.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>3.3 Processing of Personal Data; GDPR.</strong> To the extent Licensor is a processor or subprocessor of Personal Data subject to the GDPR, the Standard Contractual Clauses govern that processing.
                </p>

                <h3 style={{ fontSize: '1.1rem', marginTop: '1.5rem', marginBottom: '0.5rem', color: '#111827', fontWeight: '600', textAlign: 'left' }}>4. CONFIDENTIALITY</h3>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>4.1 Confidential Information.</strong> "Confidential Information" is non-public information that is designated "confidential" or that a reasonable person should understand is confidential, including Customer Data, Support Data, the terms of this Agreement, and Customer's account authentication credentials.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>4.2 Protection of Confidential Information.</strong> Each party will take reasonable steps to protect the other's Confidential Information and will use the other party's Confidential Information only for purposes of the parties' business relationship.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>4.3 Disclosure required by law.</strong> A party may disclose the other's Confidential Information if required by law, but only after it notifies the other party (if legally permissible) to enable the other party to seek a protective order.
                </p>

                <h3 style={{ fontSize: '1.1rem', marginTop: '1.5rem', marginBottom: '0.5rem', color: '#111827', fontWeight: '600', textAlign: 'left' }}>5. SERVICE LEVEL AGREEMENTS (SLA)</h3>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  Licensor may offer further availability and support obligations for an Offering. Such service level agreement ("SLA") will be made available by the Publisher at the applicable URL for such SLA or as otherwise communicated to Customer.
                </p>

                <h3 style={{ fontSize: '1.1rem', marginTop: '1.5rem', marginBottom: '0.5rem', color: '#111827', fontWeight: '600', textAlign: 'left' }}>6. VERIFYING COMPLIANCE</h3>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  Customer must keep records relating to Offerings it and its Affiliates use or distribution. At Licensor's expense, Licensor may verify Customer's and its Affiliates' compliance with this Agreement by directing an independent auditor to conduct an audit.
                </p>

                <h3 style={{ fontSize: '1.1rem', marginTop: '1.5rem', marginBottom: '0.5rem', color: '#111827', fontWeight: '600', textAlign: 'left' }}>7. REPRESENTATION AND WARRANTIES</h3>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>7.1</strong> Licensor represents and warrants that: (a) it has full rights and authority to enter into this Agreement; (b) the Offering will substantially conform to the Documentation; (c) the Offering will not infringe or violate any third party intellectual property rights; and (d) Licensor will comply with applicable laws including Data Protection Laws and Anti-Corruption Laws.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>7.2 Disclaimer.</strong> Except as expressly stated in this Agreement, the Offering is provided as is. To the maximum extent permitted by law, Licensor disclaims any and all other warranties including of merchantability or fitness for a particular purpose.
                </p>

                <h3 style={{ fontSize: '1.1rem', marginTop: '1.5rem', marginBottom: '0.5rem', color: '#111827', fontWeight: '600', textAlign: 'left' }}>8. DEFENSE OF THIRD-PARTY CLAIMS</h3>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>8.1 By Customer.</strong> Customer will defend Licensor from third party claims arising from Customer's violation of this Agreement and will indemnify Licensor for all reasonable attorney's fees and damages finally awarded.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>8.2 By Licensor.</strong> Licensor will defend Customer from claims that the use of the Offering infringes third party intellectual property rights and will indemnify Customer for all reasonable attorney's fees and damages finally awarded.
                </p>

                <h3 style={{ fontSize: '1.1rem', marginTop: '1.5rem', marginBottom: '0.5rem', color: '#111827', fontWeight: '600', textAlign: 'left' }}>9. LIMITATION OF LIABILITY</h3>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  For each Offering, each party's maximum, aggregate liability to the other under this Agreement is limited to direct damages not to exceed the amounts Customer paid for the Offerings during the term of the applicable licenses.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  In no event will either party be liable for indirect, incidental, special, punitive, or consequential damages, or loss of use, loss of profits, or interruption of business.
                </p>

                <h3 style={{ fontSize: '1.1rem', marginTop: '1.5rem', marginBottom: '0.5rem', color: '#111827', fontWeight: '600', textAlign: 'left' }}>10. PRICING AND PAYMENT</h3>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  Microsoft will invoice and charge Customer under the terms of the Microsoft Commercial Marketplace Terms of Use and applicable Order.
                </p>

                <h3 style={{ fontSize: '1.1rem', marginTop: '1.5rem', marginBottom: '0.5rem', color: '#111827', fontWeight: '600', textAlign: 'left' }}>11. TERM AND TERMINATION</h3>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>11.1 Term.</strong> This Agreement is effective until terminated by a party, as described below. The term for each Order will be set forth therein.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>11.2 Termination without cause.</strong> Either party may terminate this Agreement or any Order without cause on 60 days' notice.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>11.3 Termination for cause.</strong> Either party may terminate this Agreement immediately on notice if the other party materially breaches the Agreement and fails to cure the breach within 30 days after receipt of notice.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>11.4 Suspension.</strong> Licensor may suspend use of the Offering without terminating this Agreement during any period of material breach.
                </p>

                <h3 style={{ fontSize: '1.1rem', marginTop: '1.5rem', marginBottom: '0.5rem', color: '#111827', fontWeight: '600', textAlign: 'left' }}>12. MISCELLANEOUS</h3>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>12.1 Entire Agreement.</strong> This Agreement supersedes all prior communications regarding the subject matter covered in this Agreement.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>12.2 Independent contractors.</strong> The parties are independent contractors.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>12.3 Assignment.</strong> Either party may assign this Agreement to an Affiliate, but it must notify the other party in writing.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>12.4 Severability.</strong> If any part of this Agreement is held to be unenforceable, the rest of the Agreement will remain in full force and effect.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>12.5 Notices.</strong> Notices must be in writing and will be treated as delivered on the date received at the address or email transmission date.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>12.6 Applicable law and jurisdiction.</strong> This Agreement is governed by the laws of Greece and EU and the parties submit to the non-exclusive jurisdiction of the courts of Greece.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>12.7 Compliance with laws.</strong> Both parties will comply with all laws and regulations applicable to their respective performance under this Agreement.
                </p>
                
                <p style={{ marginBottom: '0.75rem' }}>
                  <strong>12.8 Data Processing Agreement.</strong> The Data Processing Agreement available at <a href="/dpa">https://meta-365.com/dpa</a> applies to and forms an integral part of this Agreement.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="footer">
          <div className="container">
            <div className="footer-grid">
              <div className="footer-column">
                <h4>Products</h4>
                <ul>
                  <li><a href="/solutions/pentities">pEntities</a>
                    <ul className="footer-subnav">
                      <li><a href="/solutions/automation">Automation Module</a></li>
                      <li><a href="/solutions/ticketing">Ticketing Module</a></li>
                      <li><a href="/solutions/hr-template">HR Module</a></li>
                      <li><a href="/solutions/case-management">Legal Module</a></li>
                      <li><a href="/solutions/hr-hub">Employee Module</a></li>
                    </ul>
                  </li>
                  <li><a href="/solutions/pshareemail">PShareEmail</a></li>
                  <li><a href="/solutions/docsearch">DocSearch Tool</a></li>
                  <li><a href="/solutions/searchassistant">Search Assistant</a></li>
                </ul>
              </div>
              <div className="footer-column">
                <h4>Company</h4>
                <ul>
                  <li><a href="/about">About Us</a></li>
                  <li><a href="/get-started">Get Started</a></li>
                  <li><a href="/contactus">Contact Us</a></li>
                  <li><a href="/plans-pricing">Plans & Pricing</a></li>
                </ul>
              </div>
              <div className="footer-column">
                <h4>Support</h4>
                <ul>
                  <li><a href="/knowledge">Knowledge Base</a></li>
                  <li><a href="/technical-support">Technical Support</a></li>
                </ul>
              </div>
              <div className="footer-column">
                <h4>Contact Us</h4>
                <div className="footer-office">
                  <p className="office-name">Athens Office</p>
                  <p>365 Kifisias Avenue, Kifisia, 14561</p>
                  <p>Ground Floor, Inside the Arcade</p>
                  <p>Tel: (+30)-210-260-3764</p>
                </div>
                <div className="footer-office">
                  <p className="office-name">Thessaloniki Office</p>
                  <p>15 Nikiforou Ouranou & Minotavrou Streets</p>
                  <p>Thessaloniki, 54627, PORTO CENTER, Building G1, 3rd Floor</p>
                  <p>Tel: (+30)-231-005-3361</p>
                </div>
                <div className="footer-office">
                  <p className="office-name">Crete Office</p>
                  <p>Kisamos, Chania</p>
                  <p>Tel: (+30)-2822-051309</p>
                </div>
                <p className="footer-email">info@meta-365.com</p>
              </div>
            </div>
            <div className="footer-bottom">
              <p>&copy; 2026 Meta-365. All rights reserved.</p>
              <div className="footer-social">
                <a href="https://www.linkedin.com/company/meta-365" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><img loading="lazy" decoding="async" src="data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%20fill='white'%3E%3Cpath%20d='M4.98%203.5C4.98%204.88%203.87%206%202.5%206S0%204.88%200%203.5%201.12%201%202.5%201s2.48%201.12%202.48%202.5zM.25%208h4.5v13H.25V8zM8.5%208h4.31v1.78h.06c.6-1.14%202.07-2.34%204.26-2.34C21.5%207.44%2022.5%2010%2022.5%2014.02V21H18v-6.1c0-1.46-.03-3.33-2.03-3.33-2.03%200-2.34%201.58-2.34%203.22V21H8.5V8z'/%3E%3C/svg%3E" alt="LinkedIn" width="18" height="18" /></a>
                <a href="https://www.facebook.com/profile.php?id=61589941284929" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><img loading="lazy" decoding="async" src="data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%20fill='white'%3E%3Cpath%20d='M24%2012.07C24%205.4%2018.63%200%2012%200S0%205.4%200%2012.07C0%2018.1%204.39%2023.1%2010.13%2024v-8.44H7.08v-3.49h3.05V9.41c0-3.02%201.79-4.69%204.53-4.69%201.31%200%202.68.24%202.68.24v2.97h-1.51c-1.49%200-1.96.93-1.96%201.89v2.25h3.33l-.53%203.49h-2.8V24C19.61%2023.1%2024%2018.1%2024%2012.07z'/%3E%3C/svg%3E" alt="Facebook" width="18" height="18" /></a>
              </div>
              <div className="footer-links">
                <a href="/privacy-policy">Privacy Policy</a>
                <a href="/terms-of-use">Terms & Conditions</a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

export default TermsOfUse;

